<template>
  <Layout :footer-style="2">
    <div class="ecopPage">
      <div class="ecopPage_content">
        <StaticBanner :banner-date="bannerDate" />
        <div class="content_body">
          <div class="ecop-one">
            <div class="position-relative" data-aos="fade-up" v-for="(item, index) in tabList" :key="index">
              <div class="container tab-block pt-lyd-120" :class="item.type == 1 ? 'tab-block-left' : 'tab-block-right'">
                <div class="tab-block-title">{{ item.title }}</div>
                <div class="tab-block-text">{{ item.content }}</div>
                
              </div>
              <div class="bg-block">
                <img :src="item.img" alt="" />
              </div>
            </div>
          </div>
          <EcopAiBlock :item-list="itemList" title="平台价值" content="云架构、低代码、微服务" />
          <div class="practice-section">
            <div class="ecop-ai-page_title container">
              <div class="font-size-24 fw-bold tab-block_titles text-center lyd-title-colo1 color-black">平台优势</div>
              <p class="font-size-14 text-center tab-block_titles">云架构、低代码、微服务</p>
            </div>
            <ExpandableCards :items="practiceList" />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style lang="scss">

</style>
<script>
import Layout from "@/components/common/Layout";
import StaticBanner from "@/components/common/staticBanner/index.vue";
import EcopAiBlock from "@/components/common/ecopAiBlock/index.vue";
import ExpandableCards from '@/components/common/ExpandableCards.vue'

export default {
  name: "ecopPage",
  components: { StaticBanner, Layout, EcopAiBlock, ExpandableCards },
  data() {
    return {
      menus: [],
      bannerDate: {
        url: require("@/assets/newImages/ECOP/ECOP_banner@2x.png"),
        title: '<span style="color:#152131">智慧创新平台</span><span style="color:#1B75ED">ECOP</span>',
        content: '<span style="color:#586E8A">云架构、低代码、微服务</span>',
        contentWidth: '600px'
      },
      tabList: [
        {
          type: 1,
          img: require("@/assets/newImages/ECOP/大数据_bj@2x.png"),
          title: "大数据、微服务支持能力",
          content:
            "灵活的进行各种资源部署,将分布在各处的资源综合利用负载由单个节点转移到多个，从而提高效率，分布式可以避免由于单个节点失效而使整个系统崩溃的危险",
        },
        {
          type: 2,
          img: require("@/assets/newImages/ECOP/低代码_bj@2x.png"),
          title: "低代码建模能力",
          content:
            "通过不同需求进行业务场景、财务建模，搭建业务底层结构框架实现数据多视角填报、计算、展现和分析且支持动态多维汇总，动态成员公式和灵活的计算逻辑个性化展示，即时呈现，即时更新，更是做到了0代码鼠标拖带式操作交互。 ",
        },
      ],
      itemList: [
        {
          img: require("@/assets/newImages/ECOP/ECOP_1@2x.png"),
          title: "迭代升级，快速响应",
          content: "覆盖业务应用、流程构建、数据服务、智能决策等数字化管理要素，助力企业敏捷构建业务应用服务并不断迭代升级，快速响应市场与客户需求。",
        },
        {
          img: require("@/assets/newImages/ECOP/ECOP_2@2x.png"),
          title: "聚合服务，平台衍生",
          content: "统一基座，统一服务，统一组件，所有服务在平台中衍生，促进业务的标准化规范化和统一化",
        },
        {
          img: require("@/assets/newImages/ECOP/ECOP_3@2x.png"),
          title: "规模化创新，提高业务敏捷度",
          content: "具有快速编排组合服务能力，支持企业规模化创新，提高业务的敏捷有效降低试错成本",
        },
        {
          img: require("@/assets/newImages/ECOP/ECOP_4@2x.png"),
          title: "共享服务，快速复用",
          content: "通过业务抽象，将各项能力，提炼为基础服务并下沉，提供共享服务，为前台不断变化的业务提供支撑，实现服务快速复用",
        },
        {
          img: require("@/assets/newImages/ECOP/ECOP_5@2x.png"),
          title: "数据互通，支持业务决策和优化",
          content: "各应用数据天然互通，构建企业数据资产，解决数据不一致问题，发挥数据价值支持业务的决策和优化",
        },
      ],
      practiceList:[
        {
          number: '01',
          title: '云原生、微服务',
          content: '各类的功能按照微服务的方式拆分，独立提供服务，各服务都提供集群的方式，避免单点故障；服务在安全方面，主要提供安全日志，分层权限，数据加密等方式避免系统出现安全风险，底层运行环境支持微软Azure Stack的服务器或者专属服务器',
          image: require('@/assets/newImages/ECOP/卡片_未选中状态@2x.png'),
          image1: require('@/assets/newImages/ECOP/卡片_选中状态@2x.png')
        },
        {
          number: '02',
          title: '强大的业务能力和<br>平台能力',
          content: '可依据不同的数据分类和特性，采用不同的数据存储和管理模式的组合，尽可能的达到性能和空间的最优配置，提供元数据的管理和定义功能， 更好的管理和使用数据，使得数据的应用范围更加广泛，提供标准的数据接入服务和数据访问服务，更好的集成不同的业务系统和分析系统，更快的创造系统应用价值',
          image: require('@/assets/newImages/ECOP/卡片_未选中状态@2x.png'),
          image1: require('@/assets/newImages/ECOP/卡片_选中状态@2x.png')
        },
        {
          number: '03',
          title: 'Business Connector 实现<br>业财融合新模式',
          content: '通过连接器将来源于业务系统等信息无缝与管理中台整合。让业财融合通过智能报账实现分切面，统一数据连接器充分结合，让连接+报账实现业财的全面融合',
          image: require('@/assets/newImages/ECOP/卡片_未选中状态@2x.png'),
          image1: require('@/assets/newImages/ECOP/卡片_选中状态@2x.png')
        }
      ],
      windowWidth: document.documentElement.clientWidth,
    };
  },
  mounted() {
    
  },
  methods: {},
};
</script>
